import React from 'react';
import { GlobalStore } from '@client:common/global-store';
import { Dialog } from '@client:common/overlay/dialog';
import { LoginForm } from '../../session-manager/views/login-form/LoginForm';
import { SessionManagerService } from '../../session-manager/services/SessionManagerService';
import { ProgressIndicator } from '@client:common/overlay/progress-indicator';
import { Notification } from '@client:common/overlay/notification';
import { IconButton } from '@client:common/button';
import { Ripple } from '@client:common/effects/ripple';
import { Icon } from '@client:common/icon';
import { AuthenticatedAccount } from '@client:common/AuthenticatedAccount';

export default function useSession() {
  const globalStore = GlobalStore.getInstance();

  const ensureAuthenticated = async (): Promise<AuthenticatedAccount> => {
    const authenticatedAccount = globalStore.valueOf('authenticatedAccount');

    if (!authenticatedAccount) {
      return new Promise<AuthenticatedAccount>((resolve, reject) => {
        const sessionManagerService = SessionManagerService.getInstance();
        const dialogInstance = Dialog.create(
          <React.Fragment>
            <IconButton
              className='login-dialog__close'
              style='basic'
              color='primary'
              onClick={() => {
                if (dialogInstance) dialogInstance.close();
                reject(new Error('Login cancelled by user.'));
              }}
            >
              <Ripple fixed duration={1000} />
              <Icon icon='close' />
            </IconButton>
            < LoginForm
              onLogin={(email, password) => {
                ProgressIndicator.show();
                sessionManagerService
                  .signIn(email, password)
                  .then((acc) => {
                    globalStore.update({ authenticatedAccount: acc });
                    if (dialogInstance) dialogInstance.close();
                    resolve(acc);
                  })
                  .catch(() => {
                    Notification.open(
                      'Email or password is incorrect, please try again'
                    );
                  })
                  .finally(() => {
                    ProgressIndicator.hide();
                  });
              }}
            />
          </React.Fragment>
        )
          .addClassName('login-dialog')
          .open();
      });
    }
    return authenticatedAccount;
  };

  return { ensureAuthenticated };
}
